import {EntityService} from "@/model/service/entity-service"
import {PickupDiff} from "@/model/entity/pickup-diff/pickup-diff"
import {AxiosPromise} from "axios"
import moment from "moment"

class PickupDiffService extends EntityService<PickupDiff> implements IPickupDiffService {
  constructor() {
    super("pickupdiff", PickupDiff)
  }

  create(entity: PickupDiff): AxiosPromise<any> {
    const pickupDay = moment(new Date(entity.pickupDate))
    const pickupTimeFrom = moment(new Date(entity.pickupTimeFrom))
    const pickupTimeTo = moment(new Date(entity.pickupTimeTo))
    return this.$http.post(this.path + "/new_pickupdiff", {
      dateFrom: pickupDay
        .millisecond(pickupTimeFrom.millisecond())
        .second(pickupTimeFrom.second())
        .minute(pickupTimeFrom.minute())
        .hour(pickupTimeFrom.hour())
        .toDate()
        .getTime(),
      dateTo: pickupDay
        .millisecond(pickupTimeTo.millisecond())
        .second(pickupTimeTo.second())
        .minute(pickupTimeTo.minute())
        .hour(pickupTimeTo.hour())
        .toDate()
        .getTime(),
      name: entity.name,
      street: entity.street,
      houseNumber: entity.houseNumber,
      postalCode: entity.postalCode,
      city: entity.city,
      phone: entity.phone,
      email: entity.email,
      contact: entity.contactName,
      weight: entity.weight,
      parcels: entity.numberOfParcels,
      remark: entity.note
    })
  }

  cancel(pickupDiffs: PickupDiff[]) {
    return this.$http.post(this.path + "/cancel_pickupdiff", {
      dispref: pickupDiffs.map(pickupDiff => pickupDiff.dispref)
    })
  }

  checkZipCodeCountry(entity: PickupDiff) {
    return this.$http.get("deliveryAddress/check?zipcode=" + entity.postalCode + "&countryCode="
    + entity.countryIsoCode + "&city=" + entity.city)
  }
}

export interface IPickupDiffService extends EntityService<PickupDiff> {
  cancel(pickupDiffs: PickupDiff[]): AxiosPromise<any>
}

const service = new PickupDiffService()

export const pickupDiffService = service
